import { ColliEnumClient } from '@frontend/colli/api';
import { ColliAction, ColliActionName } from '@frontend/colli/types';
import { useAppSelector } from '@frontend/common';
import { SelectOption } from '@frontend/components/basic-forms';
import { fetchGeneralWorkflowActions, workflowSharedStore } from '@frontend/workflow/redux';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import { ColliActionSelectProps } from './colli-action-select.component';

interface ViewProps {
    options: SelectOption<ColliActionName>[];
}

const useColliActionSelect = (props: ColliActionSelectProps): ViewProps => {
    const [actions, changeActions] = useState<string[]>([]);
    const workflowSharedState = useAppSelector(useSelector, workflowSharedStore);

    useEffect(() => {
        props.dispatch && props.dispatch(fetchGeneralWorkflowActions());
        ColliEnumClient.fetchColliActions().then(changeActions);
    }, []);

    const options = useMemo(() => {
        if (!actions || !workflowSharedState.generalWorkflowActions) return [];
        return [...actions, ...workflowSharedState.generalWorkflowActions].map((action) => {
            const found = ColliAction.ALL.find((t) => t.value.toString() === action);
            if (found) return { value: found.value.toString(), label: found.value, display: found.displayName };
            else
                return {
                    value: action,
                    label: action.replace(/_/g, ' ')
                };
        });
    }, [actions, workflowSharedState.generalWorkflowActions]);

    return { options };
};

export default useColliActionSelect;
